import anime from 'animejs/lib/anime.es.js';
import AOS from 'aos';
import confetti from 'canvas-confetti'



// // create a new flipdown instance and pass the selector string
// window.flip = new FlipDown(new Date().getTime() + 60000 * 10, 'flipdown');




// window.FlipDown = FlipDown

window.confetti = confetti
// import tab from './tab.js';
window.anime = anime
window.AOS = AOS


window.motionQuery = matchMedia('(prefers-reduced-motion)');
// console.log(window.motionQuery.matches)

window.AOS.init({
    disable: window.motionQuery.matches, 
    startEvent: 'DOMContentLoaded',
    initClassName: 'aos-init',
    animatedClassName: 'aos-animate',
    useClassNames: true, 
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,
    offset: 200,
    delay: 0,
    duration: 1000,
    easing: 'ease',
    once: false,
    mirror: true,
    anchorPlacement: 'top-bottom',
    });

// document.loadTabs() = tab;

// on document loaded
$(document).ready(function() {
    // get ever odd element from timeline-item class
    const timelineItemsodd = document.querySelectorAll('.timeline-item:nth-child(odd)');
    const timelineItemseven = document.querySelectorAll('.timeline-item:nth-child(even)');
    // loop through each element and add class to it
    timelineItemsodd.forEach(function(item) {
      item.querySelector(".description").setAttribute('data-aos', 'fade-right');
    });
  
    timelineItemseven.forEach(function(item) {
      item.querySelector(".description").setAttribute('data-aos', 'fade-left');
    });


    window.AOS.refreshHard();
})

document.addEventListener('DOMContentLoaded', () => {
  // get new date for 1/27/2022 17:30:00  
  // new Date(2022, 1, 27, 17, 30, 0, 0) as a unix timestamp
  const flipdown = new FlipDown(1643326200, 'flipdown').start();


})
/// For centenial pages
if(!window.motionQuery.matches) {
  window.anime({
    targets: '.slide-down',
    keyframes: [
      {top: "0"},
    ],
    duration: 3000,
    easing: 'easeInOutElastic(1, .6)',
    loop: false
    });

    window.anime({
    targets: '.logo-slideover',
    keyframes: [
      {opacity: 1},
    ],
    duration: 2000,
    easing: 'linear',
    loop: false
    });
}
else{
  $('.slide-down').removeClass('transform')
  $('.slide-down').removeClass('transition-all')
  $('.slide-down').addClass('top-0')
  $('.logo-slideover').css('opacity', '1')
}

var duration = 4 * 1000;
var end = Date.now() + duration;

// go MSUTEXAS!
var colors = ['#790030', '#F2B300'];

(function frame() {
    window.confetti({
    particleCount: 2,
    angle: 60,
    spread: 55,
    origin: { x: 0 },
    colors: colors,
    disableForReducedMotion: true
  });
  window.confetti({
    particleCount: 2,
    angle: 120,
    spread: 55,
    origin: { x: 1 },
    colors: colors,
    disableForReducedMotion: true
  });

  if (Date.now() < end) {
    requestAnimationFrame(frame);
  }
}());
// window.onload = frame();



// mouse hover effect
function handleHover() {
  if(window.motionQuery.matches) 
    return;
  var el = $();
  var children = $();
  var w = 0;
  var h = 0;
  var ratio = 0.05;
  var absoluteOffsetX = 0,
    absoluteOffsetY = 0,
    relativeOffsetX = 0,
    relativeOffsetY = 0;
  $('.tilt__item').on('mouseenter', function(e) {
    el = $(this);
    children = el.children();
    w = el.outerWidth();
    h = el.outerHeight();
  }).on('mousemove', function(e) {
    absoluteOffsetX = e.offsetX - w / 2;
    absoluteOffsetY = e.offsetY - h / 2;
    relativeOffsetX = absoluteOffsetX * 100 / w * 2 * ratio;
    relativeOffsetY = absoluteOffsetY * 100 / h * 2 * ratio;
    children.css({
      'transform': 'rotateY(' + relativeOffsetX + 'deg) rotateX(' + relativeOffsetY * -1 + 'deg)',
      'transition': '.10s'
    });
  }).on('mouseleave', function() {
    children.css({
      'transform': 'none',
      'transition': '1.8s ease'
    });
  });

};
handleHover();


// Timeline Amimations
// Fade in background image on scroll
// $(window).scroll(function() {
//   var oVal = ($(window).scrollTop() / $('.fade').height() * 2);
//   $('.fade').css({
//     'opacity': oVal
//   });
// });



// fade in different backgrounds on scroll
$(window).scroll(function() {
  $('.fade-in').each(function() {
    var imagePos = $(this).offset().top;

    
    var topOfWindow = $(window).scrollTop();
    if (imagePos < topOfWindow + 400) {
      //get attribute of this
      var image = $(this).attr('data-bg');

      // check if image is null


      if (image != null) {
        // change class of element
        document.getElementById(image).classList.add('opacity-100');
        // remove class with vanilla
        document.getElementById(image).classList.remove('opacity-0');
        // $(this).addClass("fade-in-active");
      }
    }
    else{
      var image = $(this).attr('data-bg');
      if (image != null) {
        // change class of element
        document.getElementById(image).classList.remove('opacity-100');
        // remove class with vanilla
        document.getElementById(image).classList.add('opacity-0');
      }
    }
  });
});


//Back to top button
$(window).scroll(function() {
  if ($(this).scrollTop() > 100) {
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
});